module.exports = __webpack_public_path__ + "img/webcam_off_button.c5421fe3.svg";